import { SET_FORM, CLEAR_FORM, FORMS_FETCH_COMPLETED, REFRESH_FORMS } from './formsActions';

export const defaultState = {
    ids: {},
    isDataFetched: false,
    attemptNumber: undefined,
};

const getFormSummary = form => {
    return {
        id: form.next_form_id,
        measure: form.measure,
        measureType: form.measure_type,
        attemptNumber: form.attempt_number,
    };
};

const formsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_FORM:
            return {
                ...state,
                ids: {
                    ...state.ids,
                    [`${action.form.measure}-${action.form.measure_type}`]: getFormSummary(
                        action.form,
                    ),
                },
            };
        case FORMS_FETCH_COMPLETED:
            return {
                ...state,
                isDataFetched: true,
            };
        case REFRESH_FORMS:
            return {
                ...state,
                isDataFetched: false,
            };
        case CLEAR_FORM: {
            const key = Object.keys(state.ids).find(
                formKey => state.ids[formKey].id === action.formId,
            );
            // eslint-disable-next-line
            const { [key]: deletedValue, ...newState } = state.ids;
            return {
                ...state,
                ids: newState,
            };
        }
        default:
            return state;
    }
};

export default formsReducer;
